import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { baseAPI } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

const getSitesAssignmentsAPI = `${baseAPI}/insync/getSitesAssignments`;
const getSitesPositionsAPI = `${baseAPI}/insync/getSitesPositions`;
const getSitesCountriesAPI = `${baseAPI}/insync/getSitesCountries`;
const getFutureInspectorIdsAPI = `${baseAPI}/insync/getFutureInspectorIds`;

export interface SiteCountry {
  siteId: number;
  branchName: string;
  country: string;
  sites?: any[];
}

@Injectable({
  providedIn: 'root'
})

export class SiteTotalService {

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getSitesAssignments(date: string): Observable<any[]> {
    const body = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal',
      date
    };

    return this.http.post<any[]>(getSitesAssignmentsAPI, body)
      .pipe(catchError(this.handleError));
  }

  getSitesPositions(date: string): Observable<any[]> {
    const body = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal',
      date
    };

    return this.http.post<any[]>(getSitesPositionsAPI, body)
      .pipe(catchError(this.handleError));
  }

  getSitesCountries(date: string): Observable<SiteCountry[]> {
    const body = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal',
      date
    };

    return this.http.post<SiteCountry[]>(getSitesCountriesAPI, body)
      .pipe(catchError(this.handleError));
  }

  getFutureInspectorIds(date: string): Observable<{ site: number, inspectorIds: string }[]> {
    const body = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal',
      date
    };

    return this.http.post<{ site: number, inspectorIds: string }[]>(getFutureInspectorIdsAPI, body)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error);

    if (!error.status) {
      return throwError('Connection Error');
    }

    if (error.error && (error.error.text === 'expire' || error.error.text === 'unauthorized')) {
      this.globalEventsManager.logout(true);
      return throwError(error.error.text);
    }

    return throwError(error.error);
  }
}
